<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import {jsPDF} from 'jspdf'; 
import DatePicker from "vue2-datepicker";
import moment from "moment";
import Swal from "sweetalert2";
import pdf from 'vue-pdf';

export default {
    components: { Layout, PageHeader, DatePicker, pdf },
    data() {
        return {
            title: "Historial gastos",
            items: [
                {
                text: "Utility",
                href: "/"
                },
                {
                text: "Starter Page",
                active: true
                }
            ],
            reembolsos:[],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filtro: '',
            direccion:'',
            desde:'',
            hasta:'',
            extension:'',
        };
    },
    computed:{
        rows() {
            return this.reembolsos.length;
        },
        filteredData() {
            // Filtramos los datos en base al campo 'filtro' 
            return this.reembolsos.filter((item) => {
                // Aquí puedes personalizar los campos a buscar
                return (
                    item.rut.toLowerCase().includes(this.filtro.toLowerCase()) ||
                    item.name.toLowerCase().includes(this.filtro.toLowerCase())
                );
            });
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredData.slice(start, end)
        },
        totalPages() {
            return Math.ceil(this.filteredData.length / this.perPage);
        },
    },
    methods:{
        ver_mas(item){
            this.$set(item, 'boton', item.boton === 'Ver más' ? 'Ver menos' : 'Ver más');
        },
        ver_comprobante(item){
            if (item.imagen_url) {
                const extension = item.imagen_url.split('.').pop().toLowerCase();
                if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) {
                    this.direccion = item.imagen_url;
                    this.extension = '';
                } else if (extension === 'pdf') {
                    this.direccion = item.imagen_url;
                    this.extension = 'pdf';
                }
            }
            this.$refs['modal-imagen'].show();
        },
        async generarPDF(item1, item2) {
            const doc = new jsPDF();
            // Agregar título
            doc.setFont("helvetica", "bold");
            doc.setFontSize(20);
            doc.text("Evento: " + item1.codigo, 20, 20);
            doc.text("Fecha: " + item2.fecha, 20, 40);
            doc.text("Monto: " + item2.monto, 20, 60);
            // Agregar imagen si está disponible
            if (item2.imagen_url) {
                try {
                    const extension = item2.imagen_url.split('.').pop().toLowerCase();

                    if (extension === "png" || extension === "jpg" || extension === "jpeg") {
                        // Si es una imagen
                        const base64 = await this.convertirImagenABase64(item2.imagen_url);
                        doc.addImage(base64, "PNG", 20, 80, 100, 100); // Posición y tamaño
                    } else if (extension === "pdf") {
                        // Si es un PDF, cargarlo dentro del PDF generado
                        const response = await fetch(item2.imagen_url);
                        const blob = await response.blob();
                        const pdfUrl = URL.createObjectURL(blob);

                        const pdfDoc = await pdfjsLib.getDocument(pdfUrl).promise;
                        const page = await pdfDoc.getPage(1);
                        const viewport = page.getViewport({ scale: 1 });

                        const canvas = document.createElement("canvas");
                        const context = canvas.getContext("2d");
                        canvas.width = viewport.width;
                        canvas.height = viewport.height;

                        await page.render({ canvasContext: context, viewport }).promise;

                        const pdfImage = canvas.toDataURL("image/png");
                        doc.addImage(pdfImage, "PNG", 20, 80, 150, 200);
                    }
                } catch (error) {
                    console.error("Error al cargar la imagen o PDF:", error);
                }
            }
            // Descargar el PDF
            doc.save("documento.pdf");
            // Agregar fecha de descarga del documento
            try {
                await axios.get(`/api/descarga_gasto/${item2.id}`);
                this.mostrarmes();
            } catch (error) {
                console.error("Error al registrar la descarga:", error);
            }
        },
        obtenerRangoFechas() {
            const hoy = new Date();
            const diaHoy = hoy.getDate();
            const mesHoy = hoy.getMonth();
            const anioHoy = hoy.getFullYear();
            let fechaInicio, fechaFin;
            if (diaHoy <= 25) {
                // Si hoy es menor o igual a 25, el rango es del 26 del mes anterior al 25 de este mes
                const mesAnterior = mesHoy === 0 ? 11 : mesHoy - 1;
                const anioInicio = mesHoy === 0 ? anioHoy - 1 : anioHoy;
                fechaInicio = new Date(anioInicio, mesAnterior, 26);
                fechaFin = new Date(anioHoy, mesHoy, 25);
            } else {
                // Si hoy es mayor a 25, el rango es del 26 de este mes al 25 del mes siguiente
                const mesSiguiente = mesHoy === 11 ? 0 : mesHoy + 1;
                const anioFin = mesHoy === 11 ? anioHoy + 1 : anioHoy;
                fechaInicio = new Date(anioHoy, mesHoy, 26);
                fechaFin = new Date(anioFin, mesSiguiente, 25);
            }
            this.desde = moment(fechaInicio).format('YYYY-MM-DD');
            this.hasta = moment(fechaFin).format('YYYY-MM-DD');
            //return { fechaInicio, fechaFin };
        },
        mostrarmes(){
            axios.get('/api/gastos_aprobados/'+this.desde+'/'+this.hasta).then(response => {
                this.reembolsos= response.data.reembolsos.filter((us) => us.boolean==true);
            });
        },
        formatFecha(fechahora){
            var orden = moment(fechahora).format('DD-MM-YYYY');
            return orden
        },
        async generarPDFtodos() {
            const doc = new jsPDF();
            doc.setFont("helvetica", "bold");
            let primeraPagina = true; // Variable para manejar la primera página
            for (const evento of this.reembolsos) {
                for (let index = 0; index < evento.gastos.length; index++) {
                    const gasto = evento.gastos[index];
                    // Agregar nueva página si no es la primera iteración
                    if (!primeraPagina) {
                        doc.addPage();
                    }
                    primeraPagina = false; // Después de la primera iteración, siempre se agregará una página
                    doc.setFontSize(20);
                    doc.text("Evento: " + evento.codigo, 20, 20);
                    doc.text("Fecha: " + gasto.fecha, 20, 40);
                    doc.text("Monto: " + gasto.monto, 20, 60);
                    if (gasto.imagen_url) {
                        try {
                            const extension = gasto.imagen_url.split('.').pop().toLowerCase();

                            if (extension === "png" || extension === "jpg" || extension === "jpeg") {
                                // Si es una imagen
                                const base64 = await this.convertirImagenABase64(gasto.imagen_url);
                                doc.addImage(base64, "PNG", 20, 80, 100, 100); // Posición y tamaño
                            } else if (extension === "pdf") {
                                // Si es un PDF, cargarlo dentro del PDF generado
                                const response = await fetch(gasto.imagen_url);
                                const blob = await response.blob();
                                const pdfUrl = URL.createObjectURL(blob);

                                const pdfDoc = await pdfjsLib.getDocument(pdfUrl).promise;
                                const page = await pdfDoc.getPage(1);
                                const viewport = page.getViewport({ scale: 1 });

                                const canvas = document.createElement("canvas");
                                const context = canvas.getContext("2d");
                                canvas.width = viewport.width;
                                canvas.height = viewport.height;

                                await page.render({ canvasContext: context, viewport }).promise;

                                const pdfImage = canvas.toDataURL("image/png");
                                doc.addImage(pdfImage, "PNG", 20, 80, 150, 200);
                            }
                        } catch (error) {
                            console.error("Error al cargar la imagen o PDF:", error);
                        }
                    }
                }
            }
            // Descargar el PDF
            doc.save("documento.pdf");
            // Registrar descargas para cada gasto
            for (const evento of this.reembolsos) {
                for (const gasto of evento.gastos) {
                    try {
                        await axios.get('/api/descarga_gasto/' + gasto.id);
                    } catch (error) {
                        console.error("Error al registrar la descarga:", error);
                    }
                }
            }
            this.mostrarmes();
        },
        convertirImagenABase64(url) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.crossOrigin = "Anonymous";
                img.src = url;
                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);
                    const base64 = canvas.toDataURL("image/png");
                    resolve(base64);
                };
                img.onerror = () => reject(new Error("No se pudo cargar la imagen"));
            });
        }
    },
    created(){
        this.obtenerRangoFechas();
        this.mostrarmes();
        /*axios.get('/api/get_gastos').then(res=>{
            this.reembolsos=res.data.eventos;
        });*/
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mt-4">
                            <div class="col-md-5">
                                <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Desde :" label-for="text" >
                                    <date-picker v-model="desde" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es" ></date-picker>
                                </b-form-group>
                            </div>
                            <div class="col-md-5">
                                <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Hasta :" label-for="text" >
                                    <date-picker v-model="hasta" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es" ></date-picker>
                                </b-form-group>
                            </div>
                            <div class="col-md-2">
                                <b-button variant="primary" block class="mb-4" @click="mostrarmes">Ver</b-button>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div class="col-md-12 text-right pb-4">
                <b-button variant="primary" v-b-popover.hover="'Se descargan todos los comprobantes que no se han descargado'" title="Descarga de comprobantes" @click="generarPDFtodos">Descargar PDF</b-button>
            </div>
            <div class="col-12" v-if="reembolsos.length>0">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Mostrar&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;recibos
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Buscar:
                                        <b-form-input
                                        v-model="filtro"
                                        type="search"
                                        placeholder="Buscar..."
                                        class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0 mt-3">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="width: 5%;">Nº</th>
                                        <th style="width: 8%;">Evento</th>
                                        <th style="width: 10%;">Coordinador</th>
                                        <th style="width: 20%;">Acción</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                        <div class="table-responsive" v-for="(item, index) in reembolsos" :key="index">
                            <table class="table">
                                <tbody>
                                    <tr>
                                        <td style="width: 5%;">{{ index+1 }}</td>
                                        <td style="width: 8%;">{{ item.codigo}}</td>
                                        <td style="width: 10%;">{{ item.coordinador_evento }}</td>
                                        <td style="width: 20%;">
                                            <b-button v-b-toggle="'accordion-'+item.id" variant="secondary" @click="ver_mas(item)">{{item.boton}}</b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <b-collapse :id="'accordion-'+item.id" accordion="my-accordion" role="tabpanel">
                                <div class="row">
                                    <div class="col-md-12" >
                                        <div class="card mt-3 shadow-sm border-light">
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="table-responsive mb-0 mt-3">
                                                            <table class="table ">
                                                                <thead>
                                                                    <tr>
                                                                        <th style="width: 5%;">Nº</th>
                                                                        <th style="width: 8%;">Tipo Gasto</th>
                                                                        <th style="width: 10%;">Monto</th>
                                                                        <th style="width: 10%;">Fecha descarga</th>
                                                                        <th style="width: 20%;">Comprobante</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(item2, index2) in item.gastos" :key="index2">
                                                                        <td>{{ index2+1 }}</td>
                                                                        <td>{{ item2.tipo_gasto}}</td>
                                                                        <td>{{ item2.monto }}</td>
                                                                        <td>{{ item2.fecha_descarga==null?'':formatFecha(item2.fecha_descarga) }}</td>
                                                                        <td>
                                                                            <b-button variant="primary" @click="ver_comprobante(item2)" size="sm">Ver</b-button>
                                                                            <b-button variant="primary" @click="generarPDF(item,item2)" size="sm" v-if="item2.fecha_descarga==null">Descarga</b-button>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-collapse>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <b-modal ref="modal-imagen" title="Comprobante de Gasto" ok-only ok-title="Cerrar">
                            <pdf :src="direccion" v-if="extension=='pdf'"></pdf>
                            <img :src="direccion" width="100%" v-else>
                        </b-modal>
                    </div>
                </div>
            </div>
            <div class="col-12" v-else>
                <div class="card">
                    <div class="card-body">
                        <h4 class="text-center">No hay gastos agregados en este periodo</h4>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>